const LinkStyles = {
    textDecoration: 'none',
    color: '#000',
    cursor: 'pointer'
}

export default LinkStyles